import { useCallback, useEffect, useState } from 'react'
import { UserPermissions } from '../../../../baseComponents/CreateRoutering/types'
import { twinFetchPostJSON } from '../../../../utils/globals/data'
import { InputTableLayoutData, InputTableURLsTable } from '../../../../baseComponents/TwinTable/InputTableLayout/types'
import { TableConfiguration } from '../../../../baseComponents/TwinTable/types'

interface VatLayoutScreenLogicProps {
    inputTableURLs: InputTableURLsTable
    userPermissions: UserPermissions
}

const useVatLayoutScreenLogic = ({ inputTableURLs }: VatLayoutScreenLogicProps) => {
    const [completeData, setCompleteData] = useState<InputTableLayoutData | null>(null)
    const [tableConfiguration, setTableConfiguration] = useState<TableConfiguration>({
        generalSearchbar: '',
        order: {},
        offset: 0,
        singleFieldsSearch: {},
        petitionNumber: 0
    })
    const getDataStr = JSON.stringify(inputTableURLs.getData)
    const getCompleteData = useCallback(async () => {
        const getDataParsed = JSON.parse(getDataStr)
        const result = await twinFetchPostJSON(getDataParsed[0], { ...getDataParsed[1], includeRelations: true })
        result.originalTableData = JSON.parse(JSON.stringify(result.tableData))
        setCompleteData(result)
    }, [getDataStr, setCompleteData])

    useEffect(() => {
        getCompleteData()
    }, [getCompleteData])

    return { completeData, setCompleteData, getCompleteData, tableConfiguration, setTableConfiguration }
}

export default useVatLayoutScreenLogic